import { render, staticRenderFns } from "./ombudsman-dashboard.vue?vue&type=template&id=4f3704a7&"
import script from "./ombudsman-dashboard.vue?vue&type=script&lang=js&"
export * from "./ombudsman-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports